import React, { useState, useEffect, useContext } from "react";

const Test = (props) => {
    return (
        <>
            <iframe
                src="http://localhost:3000/d/aded9208-99c4-45f6-9870-319b3d58c0da/test?orgId=1&viewPanel=1&kiosk&inactive=1&refresh=30s"
                width={"100%"}
                height={"500px"}
            ></iframe>
        </>
    );
};

export { Test as Test };
